import { getV3GraphRange, getEcotronGraphUtcRange } from '../../date';

export default async (api, chartOptions, payload) => {
  try {
    chartOptions.series = [];
    chartOptions.xAxis.breaks = []; // ← ADD
    chartOptions.title.text = `Measurement Graph for ${payload.topic}`;

    let paramList = '';
    let m = {};

    for (let i = 0; i < payload.params.length; i++) {
      if (i === payload.params.length - 1) {
        paramList = `${paramList}${payload.params[i].label}`;
      } else {
        paramList = `${paramList}${payload.params[i].label},`;
      }

      if (payload.params[i].label === 'Ref_Flt') {
        m['Ref_Flt/HPS'] = {
          fullform: 'Ref_Flt/HPS',
          unit: '',
          yAxis: 'Fault/Status'
        };
        m['Ref_Flt/LPS'] = {
          fullform: 'Ref_Flt/LPS',
          unit: '',
          yAxis: 'Fault/Status'
        };
        m['Ref_Flt/INT69'] = {
          fullform: 'Ref_Flt/INT69',
          unit: '',
          yAxis: 'Fault/Status'
        };
        m['Ref_Flt/KP5'] = {
          fullform: 'Ref_Flt/KP5',
          unit: '',
          yAxis: 'Fault/Status'
        };
        m['Ref_Flt/Crun_rx'] = {
          fullform: 'Ref_Flt/Crun_rx',
          unit: '',
          yAxis: 'Fault/Status'
        };
      } else {
        m[payload.params[i].label] = {
          fullform: payload.params[i].fullform,
          unit: payload.params[i].unit,
          yAxis: payload.params[i].yAxis
        };
      }
    }

    const range =
      payload.deviceType === 'ecotron'
        ? getEcotronGraphUtcRange(payload.from, payload.to)
        : getV3GraphRange(payload.from, payload.to);

    const response = await api.post(
      `${payload.deviceType}/graph/${payload.topic}`,
      {
        from: range.from,
        to: range.to,
        paramList
      }
    );

    const responseData = response.data;

    if (responseData && responseData.success === false) {
      const error = new Error(responseData.message || 'Graph request failed');
      error.response = response;
      throw error;
    }

    const measurements = Array.isArray(responseData) ? responseData : [];

    chartOptions.yAxis.forEach(axis => {
      axis.visible = false;
    });

    const allTimestamps = measurements[0]?.data?.map(d => d[0]) || [];
    const breaks = [];
    for (let j = 1; j < allTimestamps.length; j++) {
      const gap = allTimestamps[j] - allTimestamps[j - 1];
      if (gap > 30 * 60 * 1000) {
        breaks.push({
          from: allTimestamps[j - 1],
          to: allTimestamps[j],
          breakSize: 1
        });
      }
    }
    chartOptions.xAxis.breaks = breaks;

    const importRelation = await import('../graphYAxis');
    const relation = importRelation.relation();

    for (let i = 0; i < measurements.length; i++) {
      let name = measurements[i].name;
      let data = measurements[i].data;

      if (!m[name]) {
        continue;
      }

      let yAxisIndex = relation[m[name].yAxis];

      chartOptions.series.push({
        yAxis: yAxisIndex,
        name: m[name].fullform,
        data,
        tooltip: { valueSuffix: m[name].unit },
        lineWidth: 2, // ← ADD
        marker: {
          enabled: false,
          states: {
            hover: { enabled: true, radius: 4 }
          }
        }
      });

      chartOptions.yAxis[yAxisIndex].visible = true;
    }
  } catch (error) {
    throw error.response ? error.response.status : error;
  }
};
